import { Box, BoxProps, Text, ColorOptions } from '@jfs/ui-new'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'

const ExcelFileApprovals = () => {
  return (
    <Box {...styles.container}>
      <Box {...styles.subcontainer}>
        <Text fontSize={16} fontFamily={'jiotype-bold'} color={'#214796' as ColorOptions}>
          Generate Excel File Approvals
        </Text>
      </Box>
      <MasterApprovals type={ApprovalTypes.GENERATE_EXCEL_FILE} />
    </Box>
  )
}

export default ExcelFileApprovals

const styles = {
  container: {
    backgroundColor: 'WHITE',
  } as BoxProps,
  subcontainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
}
